<template>
  <c-container>
    <c-checkout-progress />
    <c-cart-booking />

    <template v-if="$store.state.cart.total > 0">
      <c-recommendation-list class="booking-overview__recommendation-list" />

      <c-banner
        v-if="cartValidation.valid"
        class="booking-overview__banner"
        color="primary"
      >
        <c-action-link
          :router-link="$t('completeBooking.link')"
          color="primary-inverse-dark"
        >
          <span v-html="$t('completeBooking.text')" />
          <c-icon
            type="chevron-right"
            :size="0.75"
          />
        </c-action-link>
      </c-banner>
    </template>
  </c-container>
</template>

<script>
import CActionLink from '../components/actionLink.vue'
import CBanner from '../components/banner.vue'
import CCartBooking from '../components/cartBooking.vue'
import CCheckoutProgress from '../components/checkoutProgress.vue'
import CContainer from '../components/container.vue'
import CIcon from '../components/icon.vue'
import CRecommendationList from '../components/recommendationList.vue'

import cartValidationMixin from '../mixins/cartValidation.js'

export default {
  name: 'VBookingOverview',

  components: {
    CActionLink,
    CBanner,
    CCartBooking,
    CCheckoutProgress,
    CContainer,
    CIcon,
    CRecommendationList
  },

  mixins: [cartValidationMixin],

  mounted () {
    this.$store.dispatch('resetCartTimer')

    this.$tracking.track(this.$route.path, 'b-ue')
    this.$tracking.eetCheckoutOverview()
  }
}
</script>

<i18n locale="en">
{
  "completeBooking": {
    "text": "Complete <strong>Booking Now</strong>",
    "link": "/booking/personal-information"
  }
}
</i18n>

<i18n locale="de">
{
  "completeBooking": {
    "text": "<strong>Buchung jetzt</strong> abschließen",
    "link": "/buchung/persoenliche-daten"
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.booking-overview__banner {
  @include vertical-spacing;

  text-align: center;
}

.booking-overview__recommendation-list {
  margin-bottom: $gutter-sm;
}
</style>
